/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMerchantAppDataRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateMerchantAppDataResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateMerchantAppData = (request: UpdateMerchantAppDataRequest, options?: CashRequestOptions) => post<UpdateMerchantAppDataRequest, UpdateMerchantAppDataResponse>("/2.0/cash/update-merchant-app-data", request, {...options, rejectOnError: true })